import { ResidentsListTemplate } from "app/features/residents/templates/ResidentsListTemplate";

export default function ResidentsScreen() {
  return <ResidentsListTemplate />;
}
